import { LEGEND_PAGE_MARGIN, computeLegendDimensions } from "../LegendBox";
import { computeElementsBoundingBox } from "../computeElementsBoundingBox";
import { findLegendPlacement } from "../findLegendPlacement";
import { renderLegendSvgString } from "../renderLegendSvgString";
import { rasterizeSvgOntoCanvas } from "../rasterizeSvgOntoCanvas";
import { truncateLegendItems } from "../truncateLegendItems";
import { computeLegendScale } from "./computeLegendScale";
import type { DrawLegendOntoCanvas } from "./types";

export const drawLegendOntoCanvas: DrawLegendOntoCanvas = async ({
  legend,
  context,
  canvasWidth,
  canvasHeight,
  pdfPageWidth,
  pdfPageHeight,
  detectedObjects,
  circuitPaths,
}) => {
  const itemCount = legend.items.length;
  if (itemCount === 0) return;

  const scale = computeLegendScale({
    pdfPageWidth,
    pdfPageHeight,
    itemCount,
  });
  const dimensions = computeLegendDimensions({ itemCount, scale });
  const margin = LEGEND_PAGE_MARGIN * scale;

  const bbox = computeElementsBoundingBox({ detectedObjects, circuitPaths });
  const placement = findLegendPlacement({
    pageWidth: pdfPageWidth,
    pageHeight: pdfPageHeight,
    bbox,
    legendWidth: dimensions.width,
    legendHeight: dimensions.height,
    margin,
  });

  const truncatedItems = truncateLegendItems({ items: legend.items, context });

  const legendSvgString = renderLegendSvgString({
    pdfPageWidth,
    pdfPageHeight,
    pixelWidth: canvasWidth,
    pixelHeight: canvasHeight,
    items: truncatedItems,
    summary: legend.summary,
    x: placement.x,
    y: placement.y,
    scale,
  });

  await rasterizeSvgOntoCanvas({
    svgString: legendSvgString,
    context,
    canvasWidth,
    canvasHeight,
  });
};
